/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import AddIcon from '@mui/icons-material/AddOutlined';

interface AddListItemButtonProps {
  onClickCallback: () => void;
}

const AddListItemButton = ({ onClickCallback }: AddListItemButtonProps) => {
  return (
    <Button
      value="Add item"
      size="small"
      variant="outlined"
      onClick={onClickCallback}
      startIcon={<AddIcon />}
      sx={{ marginBottom: '20px' }}
    >
      Add item
    </Button>
  );
};

export default AddListItemButton;
